@if (!itemGrouped) {
  <div class="float-end pt-3 pe-3">
    @if (displayActionMenu) {
      <div class="btn-group">
        <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-three-dots bi-large"></i>
        </button>
        <ul class="dropdown-menu">
          @if (allowedToSendReminder) {
            <li>
              <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(RequestStatusActionsEnum.resendRequest, actorInSendgroup)"
                id="sendReminderButton" [ngClass]="{ 'disabled': !actorInSendgroup.allowedToResendInvite }"
              translate="Request.Actions.SendReminder"></a>
            </li>
          }
          @if (allowedToEdit) {
            <li>
              <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(RequestStatusActionsEnum.editPerson, actorInSendgroup)"
                id="editPersonButton" [ngClass]="{ 'disabled': !actorInSendgroup.allowedToEdit }"
                translate="Request.Actions.EditPerson">
              </a>
            </li>
          }
          @if (allowedToSeeInvite) {
            <li><a class="dropdown-item pt-1 pb-1"
            (click)="performActionForAnId(RequestStatusActionsEnum.openEmailPreview, actorInSendgroup)" translate="Button.ShowInvite"></a>
          </li>
        }
        <!-- <li *ngIf="allowedToChangeSignatureProvider && !actorInSendgroup.completionDate">
        <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(RequestStatusActionsEnum.changeSignatureProvider, actorInSendgroup)"
          [ngClass]="{ 'disabled': !actorInSendgroup.allowedToChangeSignatureProvider}"
          translate="Request.Actions.ChangeSignatureProvider" Id="changeSignatureProviderButton">
        </a>
      </li> -->
    </ul>
  </div>
}
</div>
}
<div class="d-flex align-items-center justify-content-center"
  [ngClass]="{'accordion-mobile-item my-3': !actorInSendgroup.grouped, 'cursor-pointer': (itemGrouped && actorInSendgroup.grouped) }"
  (click)="toggleCollapseSendGroup(actorInSendgroup.personGuid)">
  <div class="ps-3 w-100 align-items-center justify-content-center"
    [ngClass]="{'text-primary fw-bold cursor-pointer': actorInSendgroup.grouped && !itemGrouped, 'py-3': !itemGrouped && isCollapsed, 'pt-3': actorInSendgroup.grouped && !isCollapsed && !first, 'mb-1': actorInSendgroup.grouped && !itemGrouped && !last, 'mb-3': actorInSendgroup.grouped && !itemGrouped && last }">
    @if (!itemGrouped) {
      @if (actorInSendgroup.grouped) {
        <span [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"
          class="cursor-pointer">
          {{actorInSendgroup.fullName}}
          <i class="bi" [ngClass]="{ 'bi-caret-down-fill': !isCollapsed, 'bi-caret-up-fill': isCollapsed}"></i>
        </span>
      }
      @if (!actorInSendgroup.grouped) {
        <span>
          {{actorInSendgroup.fullName}}
        </span>
      }
      <br />
    }
    @if (!itemGrouped && actorInSendgroup.grouped) {
      <span class="mobile-text" [ngClass]="{ 'cursor-pointer': actorInSendgroup.grouped}">{{getActionsByActor()}}</span>
    }
    @if (itemGrouped || !itemGrouped && !actorInSendgroup.grouped) {
      <span class="mobile-text {{returnStatus()}}"
      [ngClass]="{ 'cursor-pointer': actorInSendgroup.grouped }">{{getActionsByActor()}}</span>
    }
    <br />
    <span class="mobile-text"
    [ngClass]="{ 'cursor-pointer': actorInSendgroup.grouped, 'text-secundary': !actorInSendgroup.grouped || actorInSendgroup.grouped && first }">{{getDocumentsByActor()}}</span>

    @if (actorInSendgroup.declineMessage) {
      <div class="break-words">
        <div class="alert alert-danger p-1 mt-0 white-space table-alert-box-font-size me-2 mt-1 mb-0" role="alert">
          {{actorInSendgroup.declineMessage}}
        </div>
      </div>
    }

  </div>
</div>